import React from "react";

// Vetri Guide brand logo (PNG) — the app that TNPSC Tamil website presents.
const Logo = ({ className = "h-12 w-12", showText = true }) => {
  return (
    <a
      href="/"
      data-testid="brand-logo"
      className="flex items-center gap-3 group"
    >
      <span className={`${className} relative inline-flex shrink-0`}>
        <img
          src="/images/vetri-guide-logo.png"
          alt="Vetri Guide"
          className="h-full w-full object-contain drop-shadow-sm group-hover:scale-105 transition-transform"
        />
      </span>
      {showText && (
        <span className="flex flex-col leading-none">
          <span
            className="text-[16px] font-black tracking-tight text-blue-950"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            VETRI GUIDE
          </span>
          <span
            className="text-[10px] tracking-[0.16em] uppercase text-amber-600 font-semibold mt-0.5"
            style={{ fontFamily: "Outfit, Noto Sans Tamil, sans-serif" }}
          >
            by TNPSC Tamil
          </span>
        </span>
      )}
    </a>
  );
};

export default Logo;
